export const environment = {
  production: false,
  keys: {
    publicKey: 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAlCXPxZdg38B+WKWHrFO0o6WxjfMezLQw/Hd9FdquniP6KrYvlsBGNtbTfZwNweLpyujUZNdNu7Rpdi3a4BkTf+OkPSiqz8isB5IztDqUpTzZcDsq9BPtVDZtAK5gQ4eE3vx1urRSx77T56ZGspFhBpPevfT02kV8psNcU0h/Vic2KFDxEqkobtlnceHjyl3/nwWcuK29+K1m90h1C3ZveVCDg8tcQM1hCgqdVsA1mxpqJbhx7eMLcucGgtN4Dlup7nHigKRwX1O0KV+66HHxMq+YXD7pFkDTaPY+/CoBbE45ZKvPrmAoX9DGHlu6Jzpos2drga94jdhgNU1Ll7XUBwIDAQAB'
  },
  urls: {
    baseUrl: 'https://ypp.sodelsolutions.com/services/gift-card/api/gc-portal/',
    captchaUrl: 'https://ypp.sodelsolutions.com/api/'
  }
};
